<script>
  import { types, effAttckTable } from '@d/eff.js';
  import TypeIcon from '@c/TypeIcon.html';
  import Details from '@c/Details.html';
</script>



<Details class="card" type="type_table">
  <summary>
    <h3>Type Effect</h3>
  </summary>

  <table class="factor-table ml-a mr-a mb-5">
    <tr>
      <td>=></td>
      {#each types as def_type}
        <td>
          <TypeIcon type={def_type} />
        </td>
      {/each}
    </tr>

    {#each effAttckTable as atk_factors, idx}
      <tr>
        <td>
          <TypeIcon type={types[idx]} />
        </td>
        {#each atk_factors as atk_factor}
          <td class="factor" data-factor={atk_factor}>{atk_factor}</td>
        {/each}
      </tr>
    {/each}
  </table>

  <div class="df flex-center fz-s">
    <span class="factor factor-label      mr-1" data-factor="1"></span> x1.6
    <span class="factor factor-label ml-6 mr-1" data-factor="-1"></span> x0.625
    <span class="factor factor-label ml-6 mr-1" data-factor="-2"></span> x0.39
  </div>


</Details>




<style>
  @media (max-width: 500px) {
    .factor-table {
      font-size: 2.75vmin;
    }
  }

  .factor-table tr {
    border: unset;
  }
  .factor-table td {
    padding: .25em;
    box-shadow: inset 0 0 2px #9999;
  }
  .factor[data-factor] {
    color: transparent;
    font-size: 0;
  }
  .factor[data-factor="1"] {
    background-color: var(--factor-color-1);
  }
  .factor[data-factor="-1"] {
    background-color: var(--factor-color--1);
  }
  .factor[data-factor="-2"] {
    background-color: var(--factor-color--2);
  }
  .factor-label.factor-label {
    font-size: 1rem;
    width: 1em;
    height: 1em;
  }
</style>
